import React from 'react';
import RefreshIcon from '@mui/icons-material/Refresh';
import useVersionCheck from '../hooks/useVersionCheck';

export default function UpdateBanner() {
  const { updateAvailable, reload } = useVersionCheck();
  if (!updateAvailable) return null;
  return (
    <div className="update-banner" role="alert">
      <RefreshIcon fontSize="small" />
      <span className="update-banner-text">A new version is available.</span>
      <button className="update-banner-btn" onClick={reload}>
        Update now
      </button>
    </div>
  );
}
